import { ComponentTypeWithRepresentation } from './ComponentTypeWithRepresentation';
import { ComponentWithContext } from './ComponentWithContext';
import { CustomOptions, CustomOptionType } from './types';
import { WorkspaceWithFolderPath } from './WorkspaceWithFolderPath';

export const CustomOption = ({ customData }: CustomOptions) => {
  if (!customData) {
    return null;
  }

  switch (customData.type) {
    case CustomOptionType.ComponentWithContext:
      return <ComponentWithContext {...customData} />;
    case CustomOptionType.WorkspaceWithFolderPath:
      return <WorkspaceWithFolderPath {...customData} />;
    case CustomOptionType.ComponentTypeWithRepresentation:
      return <ComponentTypeWithRepresentation {...customData} />;

    default: {
      const exhaustiveCheck: never = customData;
      throw new Error(`Unhandled case: ${exhaustiveCheck}`);
    }
  }
};
